import { API } from "aws-amplify";

const updateBodyTicket = async ({ id_ticket, body, actividad, id_usuario }) => {
  try {
    const init = {
      body: {
        id: id_ticket,
        body: JSON.stringify(body),
        actividad,
        responsable: id_usuario,
      },
    };

    const result = await API.put(
      process.env.REACT_APP_HUB_API,
      "/tickets/body",
      init
    );

    if (result.success) {
      const actividad = JSON.parse(result.data.actividad);

      return { actividad };
    } else {
      return { error: result.error };
    }
  } catch (error) {
    return { error };
  }
};

const updateEstadoTicket = async ({
  id_ticket,
  estado,
  actividad,
  id_usuario,
}) => {
  try {
    const init = {
      body: {
        id: id_ticket,
        estado,
        actividad,
        responsable: id_usuario,
      },
    };

    const result = await API.put(
      process.env.REACT_APP_HUB_API,
      "/tickets/estado",
      init
    );

    if (result.success) {
      const actividad = JSON.parse(result.data.actividad);

      return { actividad };
    } else {
      return { error: result.error };
    }
  } catch (error) {
    return { error };
  }
};

export { updateBodyTicket, updateEstadoTicket };
